
import { Vue, Component } from 'vue-property-decorator';
import store from '@/store';
import { isVisibleLineBanner } from '@/lib/functions';

@Component
export default class ButtonLineMini extends Vue {
  get lang(): string {
    return store.getters['auth/lang'];
  }

  get isGroup(): boolean {
    return store.getters['auth/group'];
  }

  get isLineLogin() {
    return store.getters['auth/line']
  }

  get visibleLineButton(): boolean {
    return isVisibleLineBanner({
      lang: store.getters['auth/lang'],
      group: store.getters['auth/group'],
      isLineLogin: store.getters['auth/line'],
    });
  }
}
